/**
 * 文本格式刷：选中为文本层时展示，提取格式刷数据并触发 textBrush 埋点。
 */
import React from 'react';
import { getLocaleStore } from '@/i18n';
import { type ShortcutMenu } from '@/plugins/shortcut-menu/shortcut-menu';
import { SHORTCUT_FUNC_MAP, type IShortcutMenuItemRenderArgs } from '@/plugins/shortcut-menu/type';
import { ShortcutToolbarIconItem } from '@/plugins/shortcut-menu/views/shortcut-toolbar-widgets';
import { LayerType } from '@/version-types';
import { type TextLayer } from '../../../..';

export const textFormatBrushShortcutItem = ({ framework, activePickLayer }: IShortcutMenuItemRenderArgs) => {
    const { $t } = getLocaleStore();
    if (activePickLayer?.layerType !== LayerType.TEXT_LAYER) return null;

    return (
        <ShortcutToolbarIconItem
            name="FormatPainterBold"
            title={$t((v) => v.baseLayer.shortcutOperate.copyStyle)}
            onClick={(e) => {
                e.stopPropagation();
                const textLayer = framework.service.registration.getInstance<TextLayer>('TextLayer');
                if (!textLayer) {
                    throw new Error('TextLayer is not found');
                }
                const started = textLayer.setTextBrush(
                    activePickLayer.id,
                    $t((v) => v.baseLayer.shortcutOperate.cursorTip),
                );
                if (!started) return;
                framework.service.registration
                    .getInstance<ShortcutMenu>('ShortcutMenu')
                    .emitClick(SHORTCUT_FUNC_MAP.textBrush);
            }}
        />
    );
};
